import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/abouts/About.vue"
import GradeList from "./views/grade/list.vue"
import AddGrade from "./views/grade/add.vue"
import AddQuestionType from "./views/questionType/add.vue"
import QuestionTypeList from "./views/questionType/list.vue"

import Login from "./views/login/login.vue";
import AddAnswerType from "./views/answerType/add.vue"
import AnswerTypeList from "./views/answerType/list.vue"

import QuestionAdd from "./views/question/add.vue"
import QuestionList from "./views/question/list.vue"

import UserList from "./views/user/list.vue"
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',

      component: Login
    },
    {
      path: "/",
      name: "FEC介绍",
      children: [
        {
          path: '/about',
          component: About,
          name:"编辑",
         
        }
      ] ,
      component:Home
    },
      {
      path: "/",
      name: "等级分类",
      children: [
      {
          path: '/grade/add',
          component: AddGrade,
          name:"新增等级",
         
        }  ,
       {
          path: '/grade/grade',
          component: GradeList,
          name:"等级列表",
         
        } 
      ] ,
      component:Home
    } ,{
      path: "/",
      name: "题型分类",
      children: [
      {
          path: '/questionType/add',
          component: AddQuestionType,
          name:"新增题型",
         
        }  ,
        {
          path: '/questionType/list',
          component: QuestionTypeList,
          name:"题型列表管理",
         
        }  
      ] ,
      component:Home
    }
    // ,{
    //   path: "/",
    //   name: "答案分类",
    //   children: [
    //   {
    //       path: '/answerType/add',
    //       component: AddAnswerType,
    //       name:"新增答案类型",
         
    //     }  ,
    //     {
    //       path: '/answerType/list',
    //       component: AnswerTypeList,
    //       name:"答案类型列表管理",
         
    //     }  
    //   ] ,
    //   component:Home
    // }
    ,
    {
      path: "/",
      name: "题目管理",
      children: [
        {
          path: '/question/add',
          component: QuestionAdd,
          name:"新增题目",
         
        }  ,
         {
          path: '/question/list',
          component: QuestionList,
          name:"题目列表",
         
        }  
      ] ,
      component:Home
    } ,
    {
      path: "/",
      name: "用户管理",
      children: [
        {
          path: '/user/list',
          component: UserList,
          name:"列表",
         
        }  
      ] ,
      component:Home
    }
    // {
    //   path: "/about",
    //   name: "课程分类",
      
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/abouts/About.vue")
    // }
  ]
});
